import { render, staticRenderFns } from "./JobDetailModal.vue?vue&type=template&id=5ec084aa&scoped=true"
import script from "./JobDetailModal.vue?vue&type=script&lang=js"
export * from "./JobDetailModal.vue?vue&type=script&lang=js"
import style0 from "./JobDetailModal.vue?vue&type=style&index=0&id=5ec084aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec084aa",
  null
  
)

export default component.exports